package com.daytimegaming.ourdailyfinances.presentation.util

import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf

val CATEGORIES: ImmutableList<Pair<String, String>> = persistentListOf(
    "INCOME" to "INCOME_CHILD_SUPPORT",
    "INCOME" to "INCOME_CONTRACTOR",
    "INCOME" to "INCOME_DIVIDENDS",
    "INCOME" to "INCOME_GIG_ECONOMY",
    "INCOME" to "INCOME_INTEREST_EARNED",
    "INCOME" to "INCOME_LONG_TERM_DISABILITY",
    "INCOME" to "INCOME_MILITARY",
    "INCOME" to "INCOME_RENTAL",
    "INCOME" to "INCOME_RETIREMENT_PENSION",
    "INCOME" to "INCOME_SALARY",
    "INCOME" to "INCOME_TAX_REFUND",
    "INCOME" to "INCOME_UNEMPLOYMENT",
    "INCOME" to "INCOME_OTHER",
    "LOAN_DISBURSEMENTS" to "LOAN_DISBURSEMENTS_AUTO",
    "LOAN_DISBURSEMENTS" to "LOAN_DISBURSEMENTS_CASH_ADVANCES",
    "LOAN_DISBURSEMENTS" to "LOAN_DISBURSEMENTS_EWA",
    "LOAN_DISBURSEMENTS" to "LOAN_DISBURSEMENTS_MORTGAGE",
    "LOAN_DISBURSEMENTS" to "LOAN_DISBURSEMENTS_PERSONAL",
    "LOAN_DISBURSEMENTS" to "LOAN_DISBURSEMENTS_STUDENT",
    "LOAN_DISBURSEMENTS" to "LOAN_DISBURSEMENTS_OTHER_DISBURSEMENT",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_BNPL",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_CAR_PAYMENT",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_CASH_ADVANCES",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_CREDIT_CARD_PAYMENT",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_EWA",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_MORTGAGE_PAYMENT",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_PERSONAL_LOAN_PAYMENT",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_STUDENT_LOAN_PAYMENT",
    "LOAN_PAYMENTS" to "LOAN_PAYMENTS_OTHER_PAYMENT",
    "TRANSFER_IN" to "TRANSFER_IN_ACCOUNT_TRANSFER",
    "TRANSFER_IN" to "TRANSFER_IN_DEPOSIT",
    "TRANSFER_IN" to "TRANSFER_IN_INVESTMENT_AND_RETIREMENT_FUNDS",
    "TRANSFER_IN" to "TRANSFER_IN_SAVINGS",
    "TRANSFER_IN" to "TRANSFER_IN_TRANSFER_IN_FROM_APPS",
    "TRANSFER_IN" to "TRANSFER_IN_WIRE",
    "TRANSFER_IN" to "TRANSFER_IN_OTHER_TRANSFER_IN",
    "TRANSFER_OUT" to "TRANSFER_OUT_ACCOUNT_TRANSFER",
    "TRANSFER_OUT" to "TRANSFER_OUT_CRYPTO",
    "TRANSFER_OUT" to "TRANSFER_OUT_INVESTMENT_AND_RETIREMENT_FUNDS",
    "TRANSFER_OUT" to "TRANSFER_OUT_SAVINGS",
    "TRANSFER_OUT" to "TRANSFER_OUT_TRANSFER_OUT_FROM_APPS",
    "TRANSFER_OUT" to "TRANSFER_OUT_WIRE",
    "TRANSFER_OUT" to "TRANSFER_OUT_WITHDRAWAL",
    "TRANSFER_OUT" to "TRANSFER_OUT_OTHER_TRANSFER_OUT",
    "BANK_FEES" to "BANK_FEES_ATM_FEES",
    "BANK_FEES" to "BANK_FEES_INSUFFICIENT_FUNDS",
    "BANK_FEES" to "BANK_FEES_INTEREST_CHARGE",
    "BANK_FEES" to "BANK_FEES_FOREIGN_TRANSACTION_FEES",
    "BANK_FEES" to "BANK_FEES_OVERDRAFT_FEES",
    "BANK_FEES" to "BANK_FEES_LATE_FEES",
    "BANK_FEES" to "BANK_FEES_CASH_ADVANCE",
    "BANK_FEES" to "BANK_FEES_OTHER_BANK_FEES",
    "ENTERTAINMENT" to "ENTERTAINMENT_CASINOS_AND_GAMBLING",
    "ENTERTAINMENT" to "ENTERTAINMENT_MUSIC_AND_AUDIO",
    "ENTERTAINMENT" to "ENTERTAINMENT_SPORTING_EVENTS_AMUSEMENT_PARKS_AND_MUSEUMS",
    "ENTERTAINMENT" to "ENTERTAINMENT_TV_AND_MOVIES",
    "ENTERTAINMENT" to "ENTERTAINMENT_VIDEO_GAMES",
    "ENTERTAINMENT" to "ENTERTAINMENT_OTHER_ENTERTAINMENT",
    "FOOD_AND_DRINK" to "FOOD_AND_DRINK_BEER_WINE_AND_LIQUOR",
    "FOOD_AND_DRINK" to "FOOD_AND_DRINK_COFFEE",
    "FOOD_AND_DRINK" to "FOOD_AND_DRINK_FAST_FOOD",
    "FOOD_AND_DRINK" to "FOOD_AND_DRINK_GROCERIES",
    "FOOD_AND_DRINK" to "FOOD_AND_DRINK_RESTAURANT",
    "FOOD_AND_DRINK" to "FOOD_AND_DRINK_VENDING_MACHINES",
    "FOOD_AND_DRINK" to "FOOD_AND_DRINK_OTHER_FOOD_AND_DRINK",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_BOOKSTORES_AND_NEWSSTANDS",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_CLOTHING_AND_ACCESSORIES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_CONVENIENCE_STORES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_DEPARTMENT_STORES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_DISCOUNT_STORES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_ELECTRONICS",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_GIFTS_AND_NOVELTIES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_OFFICE_SUPPLIES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_ONLINE_MARKETPLACES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_PET_SUPPLIES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_SPORTING_GOODS",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_SUPERSTORES",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_TOBACCO_AND_VAPE",
    "GENERAL_MERCHANDISE" to "GENERAL_MERCHANDISE_OTHER_GENERAL_MERCHANDISE",
    "HOME_IMPROVEMENT" to "HOME_IMPROVEMENT_FURNITURE",
    "HOME_IMPROVEMENT" to "HOME_IMPROVEMENT_HARDWARE",
    "HOME_IMPROVEMENT" to "HOME_IMPROVEMENT_REPAIR_AND_MAINTENANCE",
    "HOME_IMPROVEMENT" to "HOME_IMPROVEMENT_SECURITY",
    "HOME_IMPROVEMENT" to "HOME_IMPROVEMENT_OTHER_HOME_IMPROVEMENT",
    "MEDICAL" to "MEDICAL_DENTAL_CARE",
    "MEDICAL" to "MEDICAL_EYE_CARE",
    "MEDICAL" to "MEDICAL_NURSING_CARE",
    "MEDICAL" to "MEDICAL_PHARMACIES_AND_SUPPLEMENTS",
    "MEDICAL" to "MEDICAL_PRIMARY_CARE",
    "MEDICAL" to "MEDICAL_VETERINARY_SERVICES",
    "MEDICAL" to "MEDICAL_OTHER_MEDICAL",
    "PERSONAL_CARE" to "PERSONAL_CARE_GYMS_AND_FITNESS_CENTERS",
    "PERSONAL_CARE" to "PERSONAL_CARE_HAIR_AND_BEAUTY",
    "PERSONAL_CARE" to "PERSONAL_CARE_LAUNDRY_AND_DRY_CLEANING",
    "PERSONAL_CARE" to "PERSONAL_CARE_OTHER_PERSONAL_CARE",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_ACCOUNTING_AND_FINANCIAL_PLANNING",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_AUTOMOTIVE",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_CHILDCARE",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_CONSULTING_AND_LEGAL",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_EDUCATION",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_INSURANCE",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_POSTAGE_AND_SHIPPING",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_STORAGE",
    "GENERAL_SERVICES" to "GENERAL_SERVICES_OTHER_GENERAL_SERVICES",
    "GOVERNMENT_AND_NON_PROFIT" to "GOVERNMENT_AND_NON_PROFIT_DONATIONS",
    "GOVERNMENT_AND_NON_PROFIT" to "GOVERNMENT_AND_NON_PROFIT_GOVERNMENT_DEPARTMENTS_AND_AGENCIES",
    "GOVERNMENT_AND_NON_PROFIT" to "GOVERNMENT_AND_NON_PROFIT_TAX_PAYMENT",
    "GOVERNMENT_AND_NON_PROFIT" to "GOVERNMENT_AND_NON_PROFIT_OTHER_GOVERNMENT_AND_NON_PROFIT",
    "TRANSPORTATION" to "TRANSPORTATION_BIKES_AND_SCOOTERS",
    "TRANSPORTATION" to "TRANSPORTATION_GAS",
    "TRANSPORTATION" to "TRANSPORTATION_PARKING",
    "TRANSPORTATION" to "TRANSPORTATION_PUBLIC_TRANSIT",
    "TRANSPORTATION" to "TRANSPORTATION_TAXIS_AND_RIDE_SHARES",
    "TRANSPORTATION" to "TRANSPORTATION_TOLLS",
    "TRANSPORTATION" to "TRANSPORTATION_OTHER_TRANSPORTATION",
    "TRAVEL" to "TRAVEL_FLIGHTS",
    "TRAVEL" to "TRAVEL_LODGING",
    "TRAVEL" to "TRAVEL_RENTAL_CARS",
    "TRAVEL" to "TRAVEL_OTHER_TRAVEL",
    "RENT_AND_UTILITIES" to "RENT_AND_UTILITIES_GAS_AND_ELECTRICITY",
    "RENT_AND_UTILITIES" to "RENT_AND_UTILITIES_INTERNET_AND_CABLE",
    "RENT_AND_UTILITIES" to "RENT_AND_UTILITIES_RENT",
    "RENT_AND_UTILITIES" to "RENT_AND_UTILITIES_SEWAGE_AND_WASTE_MANAGEMENT",
    "RENT_AND_UTILITIES" to "RENT_AND_UTILITIES_TELEPHONE",
    "RENT_AND_UTILITIES" to "RENT_AND_UTILITIES_WATER",
    "RENT_AND_UTILITIES" to "RENT_AND_UTILITIES_OTHER_UTILITIES",
    "OTHER" to "OTHER_OTHER",
)